

export const _ploca_glikolnog_rekuperatora_limcustom_bundleDraftel_make = (p) => {
  /*
  Naziv: Lajsna opslužionog panela sirina_panela-2"X"Visina_panela-2
  Broj komada: 2*količina panela
  Dim1: sirina_panela-42
  Dim2: 50
  Razvijena1: sirina_panela-42
  Razvijena2:50
  CNC crtez: "P01-00-23-"$sirina_panela-42
  Operacija1: Probijanje
  Radni centar1: Amada
  materijal: LC00000K-Lim prohrom 2.0
  */
  const bundleDraftel = {
    _draftelschemakey: 'terkk$_bundle_limcustom',
    _subform_arr: [
      {
        tempkey: -1,
        //
        identmaterijala: 'LC00000K',
        termaterijal: null,
        naziv: "Lajsna opslužionog panela " + (p.sirina - 2) + "x" + (p.visina - 2),
        sirina: (p.sirina - 42),
        duzina: 50,
        povrsina: ((p.sirina - 42) * 50) / 1000000, // (sirina * duzina) / 1000000; // konvertovana u m2
        kolicina: 2 * (p.kolicina), //
        cnccrtez: "P01-00-23-" + (p.sirina - 42),
        "terkategorija": "PP",
        "tergrupa": "LIM",
        operacija1: "OPSEC", //
        rc1: "RCPRBAM", //
        // operacija2: "OPSAV", //
        // rc2: "RCPRSER", //
        naziv_materijala: 'LIM PROHROM 2.00',
      },
    ]
  };
  return bundleDraftel;
};

